(() => {
  const root = document.querySelector('[data-ts-prototype]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  const isZhTw = (root.dataset.locale || document.documentElement.lang || '').toLowerCase() === 'zh-tw';

  const hero = root.querySelector('[data-module="hero"]');
  const heroSlides = [...root.querySelectorAll('[data-hero-slide]')];
  const heroIndicators = [...root.querySelectorAll('[data-hero-indicator]')];
  const heroPrevious = root.querySelector('[data-hero-prev]');
  const heroNext = root.querySelector('[data-hero-next]');
  const heroReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const heroInterval = 6200;
  let activeHeroSlide = 0;
  let heroTimer;

  const stopHeroRotation = () => {
    if (!heroTimer) return;
    window.clearInterval(heroTimer);
    heroTimer = undefined;
  };

  const showHeroSlide = (requestedIndex, restartRotation = true) => {
    if (!heroSlides.length) return;
    activeHeroSlide = (requestedIndex + heroSlides.length) % heroSlides.length;
    heroSlides.forEach((slide, index) => {
      const isActive = index === activeHeroSlide;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
    });
    heroIndicators.forEach((indicator, index) => {
      const isActive = index === activeHeroSlide;
      indicator.classList.toggle('is-active', isActive);
      indicator.setAttribute('aria-current', String(isActive));
    });
    if (restartRotation) startHeroRotation();
  };

  const startHeroRotation = () => {
    stopHeroRotation();
    if (heroSlides.length < 2 || heroReducedMotion.matches || document.hidden) return;
    heroTimer = window.setInterval(() => showHeroSlide(activeHeroSlide + 1, false), heroInterval);
  };

  if (hero && heroSlides.length) {
    heroPrevious?.addEventListener('click', () => showHeroSlide(activeHeroSlide - 1));
    heroNext?.addEventListener('click', () => showHeroSlide(activeHeroSlide + 1));
    heroIndicators.forEach((indicator) => indicator.addEventListener('click', () => {
      showHeroSlide(Number(indicator.dataset.heroIndicator));
    }));
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopHeroRotation();
      else startHeroRotation();
    });
    heroReducedMotion.addEventListener('change', startHeroRotation);
    showHeroSlide(0, false);
    startHeroRotation();
  }

  const journey = isZhTw ? [
    { stage: '01', kicker: 'EARTH · 泥土', title: '從一捧藏地泥土開始', copy: '泥土的來源、篩分與處理將被記錄在材料批次中。它沒有被替換，只是被認真地理解與守護。' },
    { stage: '02', kicker: 'FORM · 入模', title: '手讓輪廓慢慢出現', copy: '泥料進入模具，壓力、濕度與手感共同決定造像能否完整成形。' },
    { stage: '03', kicker: 'TIME · 風乾', title: '時間完成匠人不能催促的部分', copy: '純泥素坯自然風乾；每一批次的乾燥狀態、細微收縮與紋理都會不同。' },
    { stage: '04', kicker: 'COLOUR · 著色', title: '最後的顏色，留給匠人或你', copy: '成品系列由匠人完成；THE FINAL TOUCH 系列由持有者以現代藝術級顏料完成。' },
    { stage: '05', kicker: 'KEEP · 安放', title: '被佩戴、珍藏、陳列或安奉', copy: '一尊擦擦可以進入純銀、銅鍍金、壓克力外殼、相框、嘎烏盒或佛龕。' }
  ] : [
    { stage: '01', kicker: 'EARTH', title: 'It begins with a handful of Tibetan earth', copy: 'The source, screening and preparation of the earth are recorded in its material batch. Nothing is disguised; the material is understood and cared for as it is.' },
    { stage: '02', kicker: 'FORM', title: 'Hands allow the outline to appear', copy: 'Earth enters the mould, where pressure, moisture and touch determine whether the form emerges complete.' },
    { stage: '03', kicker: 'TIME', title: 'Time completes what the artisan cannot rush', copy: 'The unfired clay dries naturally. Every batch carries a different drying state, subtle contraction and surface texture.' },
    { stage: '04', kicker: 'COLOUR', title: 'The final colour belongs to the artisan—or to you', copy: 'Finished collections are completed by the artisan; THE FINAL TOUCH leaves the final colour to the keeper using contemporary artist-grade colour.' },
    { stage: '05', kicker: 'KEEP', title: 'Worn, archived, displayed or enshrined', copy: 'A tsa tsa can enter a handmade silver, gold-plated copper or acrylic setting, a frame, gau box or shrine.' }
  ];
  const journeyButtons = [...root.querySelectorAll('[data-journey-index]')];
  const journeyStage = root.querySelector('[data-journey-stage]');
  const journeySourceMobile = root.querySelector('[data-journey-source-mobile]');
  const journeyImage = root.querySelector('[data-journey-image]');
  const journeyKicker = root.querySelector('[data-journey-kicker]');
  const journeyTitle = root.querySelector('[data-journey-title]');
  const journeyCopy = root.querySelector('[data-journey-copy]');
  journeyButtons.forEach((button) => button.addEventListener('click', () => {
    const index = Number(button.dataset.journeyIndex);
    const item = journey[index];
    if (!item) return;
    journeyButtons.forEach((candidate) => candidate.classList.toggle('is-active', candidate === button));
    journeyStage.textContent = item.stage;
    journeyKicker.textContent = item.kicker;
    journeyTitle.textContent = item.title;
    journeyCopy.textContent = item.copy;
    journeySourceMobile.srcset = button.dataset.journeyMobile;
    journeyImage.src = button.dataset.journeyDesktop;
  }));

  const details = isZhTw ? [
    { title: '泥紋', copy: '自然乾燥留下的流動紋理，不是印刷表面的重複效果。' },
    { title: '邊緣', copy: '手工脫模與修整使每一尊的輪廓存在細微差異。' },
    { title: '氣孔', copy: '泥料中的微小氣孔被如實保留；結構性損傷則不屬於自然差異。' },
    { title: '指痕', copy: '匠人的觸碰有時會留在背面或邊緣，成為作品身份的一部分。' }
  ] : [
    { title: 'Clay texture', copy: 'Flowing texture left by natural drying, not a repeated printed surface.' },
    { title: 'Edge', copy: 'Hand release and finishing leave subtle differences in every outline.' },
    { title: 'Pore', copy: 'Tiny pores in the clay remain visible; structural damage is not treated as natural variation.' },
    { title: 'Hand mark', copy: 'A trace of the artisan’s touch can remain on the back or edge as part of the object’s identity.' }
  ];
  const detailHotspots = [
    { desktop: { x: 18, y: 28 }, mobile: { x: 18, y: 28 } },
    { desktop: { x: 32, y: 46 }, mobile: { x: 32, y: 46 } },
    { desktop: { x: 55, y: 43 }, mobile: { x: 57.2, y: 42.4 } },
    { desktop: { x: 59, y: 34 }, mobile: { x: 57.8, y: 37.5 } }
  ];
  const detailButtons = [...root.querySelectorAll('[data-detail-index]')];
  const detailTitle = root.querySelector('[data-detail-title]');
  const detailCopy = root.querySelector('[data-detail-copy]');
  const detailRing = root.querySelector('.ts-proto-detail-ring');
  const detailSourceMobile = root.querySelector('[data-detail-source-mobile]');
  const detailImage = root.querySelector('[data-detail-image]');
  const detailMobileQuery = window.matchMedia('(max-width: 720px)');
  let activeDetailIndex = 0;
  const updateDetailRing = () => {
    const breakpoint = detailMobileQuery.matches ? 'mobile' : 'desktop';
    const hotspot = detailHotspots[activeDetailIndex]?.[breakpoint];
    if (!hotspot) return;
    detailRing.style.left = `${hotspot.x}%`;
    detailRing.style.top = `${hotspot.y}%`;
    detailRing.style.transform = activeDetailIndex >= 2 ? 'translate(-50%, -50%)' : 'none';
  };
  detailButtons.forEach((button) => button.addEventListener('click', () => {
    const index = Number(button.dataset.detailIndex);
    const item = details[index];
    if (!item) return;
    activeDetailIndex = index;
    detailButtons.forEach((candidate) => candidate.classList.toggle('is-active', candidate === button));
    detailTitle.textContent = item.title;
    detailCopy.textContent = item.copy;
    detailSourceMobile.srcset = button.dataset.detailMobile;
    detailImage.src = button.dataset.detailDesktop;
    updateDetailRing();
  }));
  detailMobileQuery.addEventListener('change', updateDetailRing);
  updateDetailRing();

  const productSources = [...root.querySelectorAll('[data-result-product-source]')].reduce((map, source) => {
    map[source.dataset.resultProductSource] = {
      title: source.dataset.productTitle,
      url: source.dataset.productUrl,
      image: source.dataset.productImage
    };
    return map;
  }, {});
  const results = isZhTw ? {
    stillness: { kicker: 'YOUR MANTRA · STILLNESS', title: '靜觀', copy: '為日常留下一處安靜的凝視。' },
    compassion: { kicker: 'YOUR MANTRA · COMPASSION', title: '慈悲', copy: '提醒自己溫柔地回應人與世界。' },
    protection: { kicker: 'YOUR MANTRA · PROTECTION', title: '守護', copy: '把堅定與邊界帶在身邊。' },
    abundance: { kicker: 'YOUR MANTRA · ABUNDANCE', title: '豐盛', copy: '看見已經擁有的，也歡迎新的生長。' }
  } : {
    stillness: { kicker: 'YOUR MANTRA · STILLNESS', title: 'Stillness', copy: 'Leave a quiet point of attention in the everyday.' },
    compassion: { kicker: 'YOUR MANTRA · COMPASSION', title: 'Compassion', copy: 'A reminder to respond gently to yourself and the world.' },
    protection: { kicker: 'YOUR MANTRA · PROTECTION', title: 'Protection', copy: 'Carry steadiness and clear boundaries with you.' },
    abundance: { kicker: 'YOUR MANTRA · ABUNDANCE', title: 'Abundance', copy: 'Recognise what is already present and welcome new growth.' }
  };
  const quizIntro = root.querySelector('[data-quiz-intro]');
  const quizSteps = [...root.querySelectorAll('[data-quiz-step]')];
  const quizResult = root.querySelector('[data-quiz-result]');
  let scores = {};
  let currentStep = 0;
  const showQuizState = (state) => {
    quizIntro.hidden = state !== 'intro';
    quizResult.hidden = state !== 'result';
    quizSteps.forEach((step, index) => { step.hidden = state !== index; });
  };
  root.querySelector('[data-quiz-start]').addEventListener('click', () => {
    scores = {};
    currentStep = 0;
    showQuizState(0);
  });
  root.querySelectorAll('[data-answer]').forEach((button) => button.addEventListener('click', () => {
    const key = button.dataset.answer;
    scores[key] = (scores[key] || 0) + 1;
    if (currentStep === 0) {
      currentStep = 1;
      showQuizState(1);
      return;
    }
    const winner = Object.keys(results).reduce((best, candidate) => (scores[candidate] || 0) > (scores[best] || 0) ? candidate : best, key);
    const result = results[winner] || results.stillness;
    const product = productSources[winner] || productSources.stillness;
    root.querySelector('[data-result-kicker]').textContent = result.kicker;
    root.querySelector('[data-result-title]').textContent = result.title;
    root.querySelector('[data-result-copy]').textContent = result.copy;
    if (product) {
      const resultImage = root.querySelector('[data-result-image]');
      const resultLink = root.querySelector('[data-result-link]');
      const resultCta = root.querySelector('[data-result-cta]');
      resultImage.src = product.image;
      resultImage.alt = product.title;
      resultLink.href = product.url;
      resultLink.setAttribute('aria-label', isZhTw ? `查看 ${product.title} 商品` : `View ${product.title}`);
      resultCta.href = product.url;
      root.querySelector('[data-result-product]').textContent = product.title;
    }
    showQuizState('result');
  }));
  root.querySelector('[data-quiz-reset]').addEventListener('click', () => {
    scores = {};
    currentStep = 0;
    showQuizState('intro');
  });
})();
